import React, { BaseHTMLAttributes, FC, memo } from 'react'

import {
  EXPANDABLE_LIST_ITEM_SIZE,
  EXPANDABLE_LIST_ITEM_SIZE_MARGIN,
  ExpandableListItemContent,
  ExpandableListItemContentWrapper,
  ExpandableListItemImageWrapper,
  ExpandableListItemLink,
  ExpandableListItemWrapper,
} from '@Components/ExpandableList/styled'
import { ImageV2 } from '@Components/Image'
import { Image } from '@Generated/graphql'

export type ExpandableListItemProps = {
  image?: Image
  link?: string
  onClick?: BaseHTMLAttributes<HTMLAnchorElement>['onClick']
  title?: string
}

export const ExpandableListItem: FC<ExpandableListItemProps> = memo(({ children, image, link, onClick, title }) => {
  const contents = (
    <>
      <ExpandableListItemImageWrapper>
        {image?.url && (
          <ImageV2
            alt={title}
            height={EXPANDABLE_LIST_ITEM_SIZE - EXPANDABLE_LIST_ITEM_SIZE_MARGIN * 2}
            src={image.url}
            width={EXPANDABLE_LIST_ITEM_SIZE - EXPANDABLE_LIST_ITEM_SIZE_MARGIN * 2}
          />
        )}
      </ExpandableListItemImageWrapper>
      <ExpandableListItemContent>
        {children}
      </ExpandableListItemContent>
    </>
  )

  return (
    <ExpandableListItemWrapper>
      {link
        ? <ExpandableListItemLink href={link} onClick={onClick}>{contents}</ExpandableListItemLink>
        : <ExpandableListItemContentWrapper>{contents}</ExpandableListItemContentWrapper>}
    </ExpandableListItemWrapper>
  )
})
